import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
//////////////////////////////////////////////////

const isSingleCurrency = (costs) => R.compose(
  R.equals(1),
  R.length,
  R.uniqBy(R.prop(GC.FIELD_CURRENCY)),
)(costs);

const getInvoiceServiceIssues = (invoiceGuid, serviceIssueList, onlyGuids = true) => {
  if (G.isAnyNilOrEmpty([invoiceGuid, serviceIssueList])) return [];

  return R.compose(
    R.when(() => G.isTrue(onlyGuids), R.map(R.prop(GC.FIELD_GUID))),
    R.filter(({ workOrderInvoiceGuid }) => R.equals(invoiceGuid, workOrderInvoiceGuid)),
  )(serviceIssueList);
};

const getInvoiceServiceIssueOptions = (invoiceGuid, workOrderIssueGuids, serviceIssueOptions) => {
  if (G.isNilOrEmpty(serviceIssueOptions)) return [];

  return R.filter(
    ({ value, workOrderInvoiceGuid }) => R.and(
      R.includes(value, workOrderIssueGuids),
      R.or(G.isNilOrEmpty(workOrderInvoiceGuid), R.equals(invoiceGuid, workOrderInvoiceGuid)),
    ),
    serviceIssueOptions,
  );
};

const getOperations = (guid, isArray) => ({
  get: (prev, data) => data,
  post: (prev, data) => G.ifElse(isArray, R.concat, R.prepend)(data, prev),
  put: (prev, data) => {
    const index = R.findIndex(R.propEq(G.getGuidFromObject(data), GC.FIELD_GUID), prev);

    return R.assoc(index, data, prev);
  },
  delete: (prev) => {
    const index = R.findIndex(R.propEq(guid, GC.FIELD_GUID), prev);

    return R.remove(index, 1, prev);
  },
});

export {
  getOperations,
  isSingleCurrency,
  getInvoiceServiceIssues,
  getInvoiceServiceIssueOptions,
};
